var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayOrderTracker()
    ? _c(
        "div",
        { staticClass: "order-tracker-container", class: _vm.style() },
        [
          _c("order-tracker-minimal"),
          _vm._v(" "),
          _vm.activeOrder && !_vm.hideOrderDetailLink && !_vm.forceShow
            ? _c(
                "div",
                { staticClass: "order-view-detail", class: _vm.detailStyle() },
                [
                  _c(
                    "a",
                    {
                      staticClass: "store-navigation-color",
                      attrs: {
                        href: "/?order-details",
                        "aria-label": "view order details"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.navigateToOrderConfirmation($event)
                        }
                      }
                    },
                    [
                      _vm._v("\n\t\t\t\tView Details"),
                      _c("span", [
                        _vm._v(" for Order #" + _vm._s(_vm.displayOrderId))
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3597e15d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3597e15d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderTrackerContainer.vue
// module id = null
// module chunks = 